/* tslint:disable */
import {
  Project,
  GeoMetro
} from '../index';

declare var Object: any;
export interface ProjectGeoInterface {
  "sfdcId"?: string;
  "CreatedBy"?: string;
  "CurrencyIsoCode"?: string;
  "LastModifiedBy"?: string;
  "Name"?: string;
  "Description__c"?: string;
  "GEO_Code__c"?: string;
  "GEO_Country__c"?: string;
  "Project__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  routingProfile?: Project;
  geoMetro?: GeoMetro;
}

export class ProjectGeo implements ProjectGeoInterface {
  "sfdcId": string;
  "CreatedBy": string;
  "CurrencyIsoCode": string;
  "LastModifiedBy": string;
  "Name": string;
  "Description__c": string;
  "GEO_Code__c": string;
  "GEO_Country__c": string;
  "Project__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  routingProfile: Project;
  geoMetro: GeoMetro;
  constructor(data?: ProjectGeoInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ProjectGeo`.
   */
  public static getModelName() {
    return "ProjectGeo";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ProjectGeo for dynamic purposes.
  **/
  public static factory(data: ProjectGeoInterface): ProjectGeo{
    return new ProjectGeo(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ProjectGeo',
      plural: 'ProjectGeos',
      path: 'ProjectGeos',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "CreatedBy": {
          name: 'CreatedBy',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "LastModifiedBy": {
          name: 'LastModifiedBy',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "Description__c": {
          name: 'Description__c',
          type: 'string'
        },
        "GEO_Code__c": {
          name: 'GEO_Code__c',
          type: 'string'
        },
        "GEO_Country__c": {
          name: 'GEO_Country__c',
          type: 'string'
        },
        "Project__c": {
          name: 'Project__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        routingProfile: {
          name: 'routingProfile',
          type: 'Project',
          model: 'Project',
          relationType: 'belongsTo',
                  keyFrom: 'Project__c',
          keyTo: 'sfdcId'
        },
        geoMetro: {
          name: 'geoMetro',
          type: 'GeoMetro',
          model: 'GeoMetro',
          relationType: 'belongsTo',
                  keyFrom: 'GEO_Code__c',
          keyTo: 'sfdcId'
        },
      }
    }
  }
}
